__turbopack_context__.v({
  "detail_hero": "TF6dtq_detail_hero",
  "detail_hero_back_button": "TF6dtq_detail_hero_back_button",
  "detail_hero_background_image": "TF6dtq_detail_hero_background_image",
  "detail_hero_broadcast_info": "TF6dtq_detail_hero_broadcast_info",
  "detail_hero_continue_watching_summary": "TF6dtq_detail_hero_continue_watching_summary",
  "detail_hero_description": "TF6dtq_detail_hero_description",
  "detail_hero_mezzanine_video_initializer": "TF6dtq_detail_hero_mezzanine_video_initializer",
  "detail_hero_mezzanine_video_initializer__has_played": "TF6dtq_detail_hero_mezzanine_video_initializer__has_played",
  "detail_hero_overlay": "TF6dtq_detail_hero_overlay",
  "detail_hero_overlay_buttons": "TF6dtq_detail_hero_overlay_buttons",
  "detail_hero_overlay_buttons_kabob_menu": "TF6dtq_detail_hero_overlay_buttons_kabob_menu",
  "detail_hero_overlay_buttons_kabob_menu_external_link_icon": "TF6dtq_detail_hero_overlay_buttons_kabob_menu_external_link_icon",
  "detail_hero_overlay_buttons_website_button": "TF6dtq_detail_hero_overlay_buttons_website_button",
  "detail_hero_progress_info": "TF6dtq_detail_hero_progress_info",
  "detail_hero_show_image": "TF6dtq_detail_hero_show_image",
  "detail_hero_show_name": "TF6dtq_detail_hero_show_name",
  "detail_hero_video": "TF6dtq_detail_hero_video",
  "detail_hero_webkit_mods": "TF6dtq_detail_hero_webkit_mods",
  "fade-in": "TF6dtq_fade-in",
  "sponsorship_row__top": "TF6dtq_sponsorship_row__top",
  "user_progress_bar": "TF6dtq_user_progress_bar",
});
